import type { Nullable } from '~/types'

import { defineStore } from 'pinia'

export type TEngagementAndWeddingScrollState = {
  blockCode: string
  blockIndex: number
  cardCode: string
  shownCounts: Record<string, number>
}

export const useCatalogScrollStore = defineStore('catalogScrollStore', {
  state: () => ({
    engagementAndWeddingState: null as Nullable<TEngagementAndWeddingScrollState>,
    lastViewedCardId: null as Nullable<string>,
  }),
  actions: {
    setEngagementAndWeddingState(payload: TEngagementAndWeddingScrollState) {
      this.engagementAndWeddingState = payload
    },
    clearEngagementAndWeddingState() {
      this.engagementAndWeddingState = null
    },
    setLastViewedCardId(id: string) {
      this.lastViewedCardId = id
    },
    clearLastViewedCardId() {
      this.lastViewedCardId = null
    },
  },
})
